import Nav from "components/Nav";
import BreakingNewsBar from "components/BreakingNewsBar";
import lazy from "utils/lazy";

const BottomLeaflets = lazy(() => import("components/BottomLeaflets"));
const Footer = lazy(() => import("components/Footer"));

const PageLayout = ({
  children,
  analyticsCategory,
}: {
  children: React.ReactNode;
  analyticsCategory?: string;
}) => {
  return (
    <>
      <Nav />
      <BreakingNewsBar />
      {children}
      <BottomLeaflets analyticsCategory={analyticsCategory} />
      <Footer analyticsCategory={analyticsCategory} />
    </>
  );
};

export default PageLayout;
